import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from 'vue-meta'


// // Import Bootstrap
// import "bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";

// <!-- Template Main CSS File -->
// import "@/assets/css/index.css";
import "@/app.scss";


// <!-- Template Main JS File -->
// import "@/assets/js/main.js";


Vue.config.productionTip = false;

Vue.use(VueMeta, {
    keyName: 'metaInfo',
    attribute: 'data-vue-meta',
    ssrAttribute: 'data-vue-meta-server-rendered',
    tagIDKeyName: 'vmid',
    refreshOnceOnNavigation: true
})

router.beforeEach((to, from, next) => {
    next();
});


const render = () => {
    new Vue({
        router,
        store,
        render: h => h(App, {
            props: { error: 'You can not search for assets...' }
        })
    }).$mount("#app");
}

if (localStorage.account) {
    store.state.modules.api
        .auth(JSON.parse(localStorage.account).token)
        .then((resp) => {
            if (resp.status == 200) {
                store.state.modules.account.token = resp.data.token;
                store.state.modules.account.user = {...resp.data.user };

                render()

            }
        })
} else {
    console.log('Normal')
    render()
}